

import { Mixins, Component } from "vue-property-decorator";
import IBAsideAuth from "@/components/IBAside/IBAsideAuth.vue";
import IBHeaderAuth from "@/components/Header/HeaderAuth.vue";
import IBMobileDetector from "@/mixins/detector/IBMobileDetector";
import { ISupportInfo } from "@/api/support/interface";
import { $getSupportContact } from "@/api/support";

@Component({
	components: {
		IBHeaderAuth,
		IBAsideAuth
	},
})
export default class AuthorizationLayout extends Mixins(
	IBMobileDetector
) {

	contact: ISupportInfo | null = null

	created() {
		this.loadContact();
	}

	async loadContact() {
		this.contact = await $getSupportContact();
	}

}

